import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d2788e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timer-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator" })
], -1))

import Digit from "./digit.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'timer',
  props: {
  days: {
    type: Number,
    required: false,
  },
  hours: {
    type: Number,
    required: true,
  },
  minutes: {
    type: Number,
    required: true,
  },
  seconds: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Digit, {
      digit: __props.minutes,
      title: "MINUTES"
    }, null, 8, ["digit"]),
    _hoisted_2,
    _createVNode(Digit, {
      digit: __props.seconds,
      title: "SECONDS"
    }, null, 8, ["digit"])
  ]))
}
}

})